module.exports = __webpack_public_path__ + "static/media/Realhousey2.841e38fe.mp4";